import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, XCircle, Mail, Loader } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [error, setError] = useState('');
  const calledRef = useRef(false);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setError('Lien invalide');
      return;
    }
    if (calledRef.current) return;
    calledRef.current = true;

    axios
      .post(`${API}/auth/verify-email`, { token })
      .then(({ data }) => {
        if (data.token) {
          localStorage.setItem('access_token', data.token);
          axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        }
        setStatus('success');
        toast.success('Email confirmé !');
        setTimeout(() => navigate('/mon-compte'), 1800);
      })
      .catch((err) => {
        setError(err.response?.data?.detail || 'Lien invalide ou expiré');
        setStatus('error');
      });
  }, [token, navigate]);

  return (
    <div className="min-h-[70vh] bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-white rounded-lg shadow-sm border border-gray-200 p-10 text-center">
        {status === 'verifying' && (
          <>
            <Loader className="w-14 h-14 text-amber-500 mx-auto mb-4 animate-spin" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Vérification…</h1>
            <p className="text-gray-600 text-sm">Confirmation de votre adresse email en cours.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle2 className="w-14 h-14 text-green-600 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Email confirmé !</h1>
            <p className="text-gray-600 text-sm">Votre compte est activé. Redirection en cours…</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-14 h-14 text-red-600 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Vérification impossible</h1>
            <p className="text-gray-600 text-sm mb-6">{error}</p>
            <div className="flex flex-col gap-3">
              <Link to="/connexion" className="bg-[#E42313] text-white px-6 py-3 rounded font-semibold hover:bg-[#C11A0F]">
                Se connecter
              </Link>
              <Link to="/inscription" className="border border-gray-300 px-6 py-3 rounded font-semibold hover:bg-gray-50 inline-flex items-center justify-center gap-2">
                <Mail className="w-4 h-4" /> Créer un nouveau compte
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
